import * as React from 'react'
import { SVGProps } from 'react'
const SvgPlayArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height={124.512}
    viewBox="0 0 124.512 124.512"
    width={124.512}
    {...props}
  >
    <path d="m113.956 57.006-97.4-56.2c-4-2.3-9 .6-9 5.2v112.5c0 4.6 5 7.5 9 5.2l97.4-56.2c4-2.401 4-8.2 0-10.5z" />
  </svg>
)
export default SvgPlayArrow
